import { render, staticRenderFns } from "./OrderPrice.vue?vue&type=template&id=02844f1f"
import script from "./OrderPrice.vue?vue&type=script&lang=js"
export * from "./OrderPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports